import * as Lucide from "lucide-react";
import { OPERATIONS_NUMBERS } from "@/lib/data";

const OperationsNumbers = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="operations-numbers-section">
      <div className="container-tm">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="overline">En coulisses</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Le quotidien de
            <span className="italic text-gold"> notre équipe terrain</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {OPERATIONS_NUMBERS.map((n, i) => {
            const Icon = Lucide[n.icon] || Lucide.Sparkles;
            return (
              <div
                key={n.label}
                data-testid={`operation-number-${i}`}
                className="group bg-cream/40 hover:bg-white border border-ink/5 rounded-3xl p-10 lg:p-12 text-center transition-all duration-500 hover:shadow-lift"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-sage/10 group-hover:bg-sage transition-colors duration-500 mb-6">
                  <Icon size={24} strokeWidth={1.6} className="text-sage group-hover:text-white transition-colors" />
                </div>
                <p className="font-serif text-6xl md:text-7xl text-ink leading-none tracking-tight">
                  {n.value}
                </p>
                <p className="mt-4 text-[11px] uppercase tracking-[0.25em] font-semibold text-gold">
                  {n.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OperationsNumbers;
